'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.currentBoardSharedUsersSelector = exports.canSaveBoard = exports.getSharedUsers = exports.aliasUserPermissionsSelector = exports.createElementUserPermissionsSelector = exports.currentBoardPermissionsSelector = exports.currentBoardUserPermissionsSelector = exports.confirmedInvalidPermissions = exports.confirmedValidPermissions = exports.validatePermissions = exports.getAllPermissions = exports.getUserPermissions = exports.getUserAcl = undefined;

var _reselect = require('reselect');

var _milanoteReselect = require('../milanoteReselect/milanoteReselect');

var _elementUtil = require('../../element/elementUtil');

var _userConstants = require('../../../common/users/userConstants');

var _permissionConstants = require('../../../common/permissions/permissionConstants');

/**
 * Retrieves the ACL entry appropriate for the current user off ONLY the current element.
 */


// Constants


// Utils
var getUserAcl = exports.getUserAcl = function getUserAcl(element, userId) {
    return element.getIn(['acl', userId]) || element.getIn(['acl', _userConstants.PUBLIC_USER_ID] || 0);
}; // Lib
var getUserPermissions = exports.getUserPermissions = function getUserPermissions(elements, elementId, userId) {
    var userPermissions = 0;

    var element = elements.get(elementId);
    while (element) {
        var currentElementUserPermissions = getUserAcl(element, userId);
        userPermissions = userPermissions | currentElementUserPermissions;

        var parentId = element.getIn(['location', 'parentId']);
        element = elements.get(parentId);
    }
    return userPermissions;
};

var getAllPermissions = exports.getAllPermissions = function getAllPermissions(elements, elementId) {
    var permissionsMap = {};

    var element = elements.get(elementId);
    while (element) {
        var currentElementAcl = element.get('acl') || [];

        // Bitwise OR the user permissions so the user permissions is the MOST permissive out of all the permissions
        /* eslint-disable no-loop-func */
        currentElementAcl.forEach(function (userEntry, userKey) {
            permissionsMap[userKey] = permissionsMap[userKey] || {};
            permissionsMap[userKey].permission = permissionsMap[userKey].permission | userEntry;

            // Keep track of the closest ancestor this is shared from
            permissionsMap[userKey].elementId = permissionsMap[userKey].elementId || element.get('id');
        });
        /* eslint-enable no-loop-func */

        var parentId = element.getIn(['location', 'parentId']);
        element = elements.get(parentId);
    }

    return permissionsMap;
};

var validatePermissions = exports.validatePermissions = function validatePermissions(elements, elementId, userId, requiredPermissions) {
    if ((getUserPermissions(elements, elementId, userId) & requiredPermissions) === requiredPermissions) {
        return _permissionConstants.PERMISSION_STATES.VALID;
    }
    return (0, _elementUtil.hasRetrievedAllAncestors)(elements, elementId) ? _permissionConstants.PERMISSION_STATES.INVALID : _permissionConstants.PERMISSION_STATES.UNKNOWN;
};

var confirmedValidPermissions = exports.confirmedValidPermissions = function confirmedValidPermissions(elements, elementId, userId, requiredPermissions) {
    return validatePermissions(elements, elementId, userId, requiredPermissions) === _permissionConstants.PERMISSION_STATES.VALID;
};

var confirmedInvalidPermissions = exports.confirmedInvalidPermissions = function confirmedInvalidPermissions(elements, elementId, userId, requiredPermissions) {
    return validatePermissions(elements, elementId, userId, requiredPermissions) === _permissionConstants.PERMISSION_STATES.INVALID;
};

var currentBoardUserPermissionsSelector = exports.currentBoardUserPermissionsSelector = (0, _reselect.createSelector)(function (state) {
    return state.get('elements');
}, function (state, ownProps) {
    return ownProps.currentBoardId || ownProps.currentBoard && ownProps.currentBoard.get('id');
}, function (state) {
    return state.getIn(['app', 'currentUser', '_id']);
}, getUserPermissions);

var currentBoardPermissionsSelector = exports.currentBoardPermissionsSelector = (0, _milanoteReselect.createShallowSelector)(function (state) {
    return state.get('elements');
}, function (state, ownProps) {
    return ownProps.currentBoardId;
}, getAllPermissions);

var createElementUserPermissionsSelector = exports.createElementUserPermissionsSelector = function createElementUserPermissionsSelector() {
    return (0, _milanoteReselect.createShallowSelector)(function (state) {
        return state.get('elements');
    }, function (state, props) {
        return props.elementId || props.element && props.element.get('id');
    }, function (state) {
        return state.getIn(['app', 'currentUser', '_id']);
    }, getUserPermissions);
};

var aliasUserPermissionsSelector = exports.aliasUserPermissionsSelector = (0, _milanoteReselect.createShallowSelector)(function (state) {
    return state.get('elements');
}, function (state, props) {
    return props.element.getIn(['content', 'linkTo']);
}, function (state) {
    return state.getIn(['app', 'currentUser', '_id']);
}, function (elements, linkedBoardId, currentUserId) {
    return getUserPermissions(elements, linkedBoardId, currentUserId);
});

var getSharedUsers = exports.getSharedUsers = function getSharedUsers(boardPermissions) {
    return Object.keys(boardPermissions).filter(function (key) {
        return key !== _userConstants.PUBLIC_USER_ID;
    });
};

var canSaveBoard = exports.canSaveBoard = function canSaveBoard(elements, elementId, userId) {
    return confirmedValidPermissions(elements, elementId, userId, _permissionConstants.ACCESS_BITS.SAVE);
};

var currentBoardSharedUsersSelector = exports.currentBoardSharedUsersSelector = (0, _milanoteReselect.createShallowSelector)(currentBoardPermissionsSelector, function (currentBoardPermissions) {
    return getSharedUsers(currentBoardPermissions);
});


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/permissions/permissionsService.js
// module id = 75
// module chunks = 0